"use client";

import { useEffect } from "react";
import Link from "next/link";
import PeachIcon from "@/components/icons/PeachIcon";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4 bg-peach-gradient">
      <PeachIcon size={72} />
      <h1 className="text-3xl font-bold text-peach-800 mt-6">Something went wrong</h1>
      <p className="text-peach-400 text-sm mt-2">An unexpected error occurred.</p>
      <div className="flex gap-3 mt-8">
        <button onClick={reset} className="btn-primary">
          Try again
        </button>
        <Link href="/workflows" className="btn-secondary">
          Back to workflows
        </Link>
      </div>
    </main>
  );
}
